<template>
  <div class="gs-app gs-refresh-controls gv-integration-form">
    <div
      class="flex flex-col w-full"
    >
      <div
        v-if="
          localWebhooks.length > 0
        "
      >
        <div class="flex flex-row-reverse w-full">
          <gs-button
            size="md"
            class="p-4"
            variant="primary"
            @click="addIPNURL()"
            >{{
              $t(
                'frontend_product_step8_no_integrations_add_new_webhook'
              )
            }}</gs-button
          >
        </div>
        <VuePerfectScrollbar
        class="mt-2"
        style="max-height: 165px">
        <div
          v-for="(ipnUrl, ipnIndex) in localWebhooks"
          :key="ipnIndex"
          class="flex flex-col w-3/4 my-2"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">{{
            $t('frontend_product_step8_webhook_url')
          }}</label>
          <div class="flex flex-row w-full">
            <div class="w-11/12">
              <text-input
                v-model="ipnUrl.url"
                attribute="IPN URL"
                value="ipnUrl.link"
                :placeholder="$t('frontend_product_step8_ipn_url')"
              />
            </div>
            <gs-button
              size="icon"
              variant="ghost"
              class="is-destructive w-1/12 ml-2 h-10"
              aria-label="Delete webhook"
              title="Delete"
              @click="deleteIPNURL(ipnIndex, ipnUrl.id)"
            >
              <i class="fas fa-trash" />
            </gs-button>
          </div>
        </div>
        </VuePerfectScrollbar>
      </div>

      <div v-else class="flex flex-col w-full">
        <div class="flex flex-row-reverse w-full">
          <gs-button
            size="md"
            class="p-4"
            variant="primary"
            @click="addIPNURL()"
            >{{
              $t('frontend_product_step8_add_new_webhook')
            }}</gs-button
          >
        </div>
        <label class="text-grey-dark my-4">{{
          $t('frontend_product_step8_no_webhook')
        }}</label>
      </div>
    </div>          
  </div>
</template>

<script>
import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Integration from '@/models/WebhookIntegration';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'AddSequence',
  props: {
    model: {
      required: true,
    },
    webhooks: {
      required: true,
    },
    eventId: {
      required: true,
    },
    eventType: {
      required: true,
    },
    optinId: {},
  },
  data() {
    return {
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      video: this.model,
      selectionSubmitted: false,
      isSequenceSelectionInvalid: false,
      localWebhooks: typeof this.webhooks != 'undefined'? this.webhooks : [],
      ipnUrl: {video_id: this.model.id, url:'', event_id: this.eventId, event_type: this.eventType},
      membershipId: '',
      membershipFileId: '',
      membershipAccessLevelId: '',
      access_levels: [],
      isEditing: false,
      addbtn: false,
    };
  },

  computed: {},

  components: {
    VuePerfectScrollbar,
  },

  async created() {
  //  this.showLoader();
   
  //  this.hideLoader();
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    addIPNURL(index) {
        this.localWebhooks.push({
          id: 0,
          url: '',
          video_id: this.video.id,
          optin_id: this.optinId,
          event_id: this.eventId,
          event_type: this.eventType,
        });
    },
    async save() {
      const nonEmptyWebhooks = this.localWebhooks.filter(el => el.url !== '');
      if (nonEmptyWebhooks.length > 0) {
        const integrations = await this.model
        .webhookIntegration()
        .attach(nonEmptyWebhooks);
        
        this.localWebhooks = integrations.data.data;
      }
    },
    saveIPNURL(index) {
        this.localWebhooks.push({
          id: 0,
          link: '',
        });
    },
    async deleteIPNURL(index, ipnId) {
      if(ipnId){
        const webhook = await this.video.webhookIntegration().$find(ipnId)
        const response = await webhook.for(this.video).delete();
        if (
          typeof response.data !== 'undefined' &&
          typeof response.data.status !== 'undefined' &&
          response.data.status == true
        ) {
          this.localWebhooks.splice(index, 1);
        }
      } else {
        this.localWebhooks.splice(index,1);
      }
    },
    validate() {
      this.selectionSubmitted = true;
      return true;
    },
  },
};
</script>

<style>
.gv-integration-form { padding: 20px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); }
@media (max-width: 640px) { .gv-integration-form { padding: 16px; } .gv-integration-form .w-3\/4 { width: 100% !important; } }
</style>

<style lang="scss">
.form-setup-radio.flex {
  margin: 0;
  padding: 0;
  border: none;
  height: auto;
  position: relative;
  .ml-2 {
    margin: 0;
    label {
      color: #191d3a;
    }
    .text-grey-500 {
      font-size: 14px;
      line-height: 24px;
      color: #545671;
      margin-top: 8px;
    }
  }
  .w-6 {
    height: 24px;
    margin: 0;
    position: absolute;
    right: 0;
    top: 16px;
  }
}
</style>
